import { createSelector } from '@ngrx/store';

import { State } from './reducer';
import { selectPostUserState } from '../selectors';
import { CreatedUser } from '@models/swagger';

export const getData = createSelector(selectPostUserState, (state: State) => state.data);

export const getError = createSelector(selectPostUserState, (state: State) => state.error);

export const getLoading = createSelector(selectPostUserState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: CreatedUser | null) => T) =>
  createSelector(selectPostUserState, (state: State) => fn(state.data));
